import React, { useEffect, useState } from "react";

import "./GroupMemberList.css";
// all css comes from GroupMemberList css
import axios from "../../axios";
import { IP } from "../../internalServer";
import SuccessMemberAdded from "../SucessGroup/SuccessMemberAdded";

const GroupMemberList = ({ setAdd, setMember, list, setD, add, member }) => {
  const [group, setGroup] = useState();
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));

  useEffect(() => {
    const getGroups = async () => {
      try {
        let res = await axios.get(
          `api/v1/group/getById/${list?.id}?isFullFledged=true`
        );
        res && setGroup(res.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    getGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list, add, setD, member]);
  return (
    <div className="all_memberList_container">
      <div className="memberList_heading ">
        <div className="memberListClass">{list.name}</div>

        {teacher_id == list?.teacher?.id && !group?.isDeleted && (
          <div>
            <button
              onClick={(e) => {
                setAdd(true);
              }}
              className="add_member_memberList"
            >
              Add More Members
            </button>
          </div>
        )}
      </div>
      <div className="d-flex align-items-center justify-content-between mt-2">
        <span style={{ fontSize: "16px", color: "#455A64", fontWeight: "600" }}>
          ({group?.member?.length} members)
        </span>
        <span style={{ fontSize: "16px", color: "#455A64", fontWeight: "600" }}>
          Group type: {group?.type}
        </span>
      </div>
      <div className="d-flex align-items-center justify-content-between mt-2 mb-3">
        <span style={{ fontSize: "18px", color: "#000", fontWeight: "600" }}>
          Class-{list?.standard?.name} - {list?.section?.name}
        </span>
        <span style={{ fontSize: "18px", color: "#000", fontWeight: "600" }}>
          Subject: {list?.subject?.name}
        </span>
      </div>
      <div
        style={{ borderTop: "1px solid #CCD6DD" }}
        className="allMemeberPrposList"
      >
        {group?.member
          ?.slice()
          ?.sort((a, b) => {
            if (a?.is_moderator && !b?.is_moderator) {
              return -1; 
            }
            if (!a?.is_moderator && b?.is_moderator) {
              return 1; 
            }
            const nameA = a?.member?.name?.toUpperCase();
            const nameB = b?.member?.name?.toUpperCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          })
          ?.map((member) => (
            <div style={{ borderBottom: "1px solid #CCD6DD" }}>
              <div className="total_name_photo_member">
                <div className="member_profile_name mb-2">
                  <img
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                    }}
                    className="memberphoto"
                    alt="cross icon"
                    src={
                      member?.member?.profile_picture
                        ? IP +
                          member?.member?.profile_picture.replace(/^\./, "")
                        : "images/7.jpeg"
                    }
                  ></img>
                  <div className="memberName">{member?.member?.name}</div>
                </div>
                {member?.is_moderator  ? (
                  <></>
                ) : (
                 !group?.isDeleted &&
                  <img
                    onClick={(e) => {
                      setMember(true);
                      setD(member);
                    }}
                    alt=""
                    src="/group-img/delete_group_icon.svg"
                  />
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
    
  );
};

export default GroupMemberList;
